export const ERouteStopType = {
  Pickup: 0,

  Dropoff: 1,
}

export type ERouteStopType = (typeof ERouteStopType)[keyof typeof ERouteStopType]
